import React from 'react';

interface FormFieldProps {
  label: string;
  required?: boolean;
  children: React.ReactNode;
}

export const FormField = ({ label, required, children }: FormFieldProps) => (
  <div className="formRow">
    <label className="formLabel">
      {label}
      {required && <span style={{ color: '#d32f2f' }}> *</span>}
    </label>
    {children}
  </div>
);
